import React from 'react';
import { useNavigate } from "react-router-dom";
import { amazonLink } from './constants/Constants';

export interface HeaderInterface {
    setIsMenuOpen?: any;
}

function Header({ setIsMenuOpen }: HeaderInterface) {
    const menuIcon = require("./images/menuIcon.png");

    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate("/");
    }

    const handleOrderClick = () => {
        window.open(amazonLink, '_blank');
    }

    const handleMenuOpenClick = () => {
        setIsMenuOpen(true);
    }

    return (
        <div className="headerWrapper">
            <div className="headerLeft">
                <div className="headerName" tabIndex={0} onClick={handleHomeClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleHomeClick();
                    }
                }}>
                    JUSTLY
                </div>
            </div>
            <div className="headerRight">
                <button className="headerPlayButton" onClick={handleOrderClick}>ORDER NOW</button>
                {setIsMenuOpen && <div className="headerSettingsIconWrapper" tabIndex={0} onClick={handleMenuOpenClick} onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleMenuOpenClick();
                    }
                }}>
                    <img className="headerSettingsIcon" src={menuIcon} alt='settings'/>
                </div>}
            </div>
        </div>
    );
};

export default Header;